import { Navigate, useLocation } from "react-router-dom";

const MAP = {
  "/shop": "/domestic",
  "/store": "/domestic",
  "/products": "/domestic",
  "/domestic-lawncare": "/domestic",
  "/domestic-robotic-mowers": "/domestic",
  "/robotic-lawn-mowers": "/domestic",
  "/commercial-mowing": "/commercial",
  "/commercial-robotic-mowers": "/commercial",
  "/line-marking-robots": "/line-marking",
  "/linemarking": "/line-marking",
  "/contact-us": "/contact",
  "/get-in-touch": "/contact",
  "/service-repairs": "/service",
  "/services": "/service",
  "/repairs": "/service",
  "/servicing": "/service",
  "/winter-storage": "/lp/repairs-winter-storage",
  "/about-us": "/about",
  "/our-story": "/about",
  "/sports-clubs": "/clubs",
  "/gaa-clubs": "/clubs",
  "/privacy-policy": "/privacy",
  "/cookie-policy": "/cookies",
  "/terms-and-conditions": "/terms",
  "/terms-conditions": "/terms",
  "/cart": "/domestic",
  "/checkout": "/contact",
  "/my-account": "/",
};

const resolve = (path) => {
  const clean = path.toLowerCase().replace(/\/+$/, "") || "/";
  if (MAP[clean]) return MAP[clean];
  if (clean.startsWith("/product-category") || clean.startsWith("/shop/")) {
    if (clean.includes("line") || clean.includes("paint")) return "/line-marking";
    if (clean.includes("commercial")) return "/commercial";
    return "/domestic";
  }
  return "/";
};

export function LegacyRedirect() {
  const { pathname } = useLocation();
  return <Navigate to={resolve(pathname)} replace />;
}
